import { createFileRoute } from '@tanstack/react-router'

import styles from './styles.module.scss'
import { ModalLogin } from '@/components/mobile/modal-login'

export const Route = createFileRoute('/mobile/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className={styles.container}>
      <img
        src="/assets/login_logo.png"
        alt="Sorte LEC logo"
      />
      <button>
        <img
          src="/assets/btn_vermelho.png"
          alt="Login"
        />
      </button>
      <ModalLogin />
    </div>
  )
}
